export const isBrowser = (windowReference: Window | undefined): boolean =>
    typeof windowReference !== 'undefined' &&
    typeof windowReference.document !== 'undefined' &&
    typeof windowReference.document.createElement !== 'undefined';
